import { IconContent } from '@icons';

export const starFilled: IconContent = {
    sm: '<path d="m8 1 1.975 4.282 4.682.555-3.462 3.201.92 4.625L8 11.36l-4.114 2.303.918-4.625-3.461-3.201 4.682-.555L8 1Z" />',
    md: '<path d="m12 1.5 2.962 6.423 7.024.832-5.193 4.802 1.379 6.938L12 17.04l-6.172 3.455 1.379-6.938-5.193-4.802 7.024-.832L12 1.5Z" />',
};
